import React, { useEffect, useState, useRef } from "react";
import { Button, Image } from "react-bootstrap";
import Logo from "../resources/2022kmtwhitesm.png";

import InputForm from "./InputForm";
import { useScreenshot } from "use-react-screenshot";
import { products } from "../utils/calcs";
import SplashScreen from "./SplashScreen";
import PascalHeader from "./PascalHeader";
import CalculatorComponent from "./CalculatorComponent";

export default function Home({scaleVal}) {
 const [parSavedPerMonth, setParSavedPerMonth] = useState(0);
 const [parClicksPerMonth, setParClicksPerMonth] = useState(0);
 const [parSelectedSolutions, setParSelectedSolutions] = useState([]);
 const [parLoanCount, setParLoanCount] = useState(0);
 const [clearValuesTrigger, setClearValuesTrigger] = useState(false);
  const acronymName = "Monthly Savings Calculator";
  const [resetVals, setResetVals] = useState(false);
  const [showInputFormModal, setShowInputFormModal] = useState(false);
  const [showSplashScreen, setShowSplashScreen] = useState(true);

  const [image, takeScreenshot] = useScreenshot();
  const getImage = () => takeScreenshot(screenRef.current);

  const screenRef = useRef();

  useEffect(() => {
    if (resetVals) setResetVals(false);
  }, [resetVals]);
 
  
    // useEffect(() => {
    //   document.documentElement.style.setProperty("--background", "#17181d");
    //   document.documentElement.style.setProperty(
    //     "--overlayGradStart",
    //     "rgba(171, 142, 63, .7)"
    //   );
    //   document.documentElement.style.setProperty(
    //     "--overlayGradEnd",
    //     "rgba(171, 142, 63, 1)"
    //   );
    //    document.documentElement.style.setProperty(
    //      "--primary-font-color",
    //      "rgba(23, 24, 29, .8)"
    //    );
    //   document.documentElement.style.setProperty("--checkboxColor", "#ab8e3f");
    //   document.documentElement.style.setProperty("--rowBorderTopSize", "0px");
    // });
  



  function resetValues() {
    clearValues();
    setShowInputFormModal(false);
    setShowSplashScreen(true);
  }

  function clearValues() {
    setClearValuesTrigger(true);
  }

  function showInputForm() {
    getImage();
    setShowInputFormModal(true);
  }
  
  function getTools() {
    var ret = [];
    for (let i = 0; i < parSelectedSolutions.length; i++) {
      var prod = products.find((x) => x.Id === parSelectedSolutions[i].key);
      
      if (prod) {
        ret.push(prod.Name);
      }
    }
    return ret;
  }

  function getMoneyPerMonth() {
    return formatter.format(parSavedPerMonth);
  }
  
  function gtClicksPerMonth() {
    var tmp = parClicksPerMonth;
    var retString = getFormattedNumber(tmp).toString();
    if (tmp > 0) {
      if (tmp < 1000) {
        retString = retString + " Clicks";
      } else {
        tmp = tmp / 1000;
        retString = getFormattedNumber(tmp).toString() + "K Clicks";
      }
    }
    else {
      return "0";
    }

    return retString;
  }

  const getFormattedNumber = (input) => {
    input = Math.round(input);
    return input.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return (
    <>
      <SplashScreen
        setShowSplashScreen={setShowSplashScreen}
        showSplashScreen={showSplashScreen}
      />

      <InputForm
        showModal={showInputFormModal}
        setShowModal={setShowInputFormModal}
        acronymName={acronymName}
        Logo={Logo}
        resetApp={resetValues}
        getImage={getImage}
        image={image}
        monthlyClicks={gtClicksPerMonth}
        monthlyDollars={getMoneyPerMonth}
        tools={getTools}
        loanCount={ parLoanCount }
      />

      <div className="outer-cont">
        <div
          className={[
            "page-container",
            showInputFormModal ? "hidden" : "",
          ].join(" ")}
        >
          <div className={["page-header-row", "mw-row"].join(" ")}>
            <div>
              <Image src={Logo} className="kmt-logo" />
            </div>
          </div>

          <PascalHeader />

          <CalculatorComponent 
            scaleVal={scaleVal} 
            screenRef={screenRef} 
            clearValuesTrigger={clearValuesTrigger}
            setClearValuesTrigger={setClearValuesTrigger}
            setParSavedPerMonth={setParSavedPerMonth}
            setParClicksPerMonth={setParClicksPerMonth}
            setParSelectedSolutions={setParSelectedSolutions}
            setLoanCount={setParLoanCount}
          />

       
          <div className={["page-footer", "mw-row"].join(" ")}>
            <Button
              className={["kmt-savings-button"].join(" ")}
              variant="secondary"
              onClick={resetValues}
            >
              Reset
            </Button>
            <Button
              className={["kmt-savings-button"].join(" ")}
              variant="secondary"
              onClick={clearValues}
            >
              Clear
            </Button>
            <div />
            <Button
              className={["kmt-savings-button", "save"].join(" ")}
              variant="success"
              onClick={showInputForm}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
